export enum DepartmentType {
  Warehouse = 1,
  Reclamation = 2,
}
